import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Hidden from '@material-ui/core/Hidden';
import PanelInfo from '../../labels/PanelInfo';
import Menu from './Menu';
import Error from '../../dialogs/Error';

class Index extends React.Component {
    
    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '60') &&
              info.security.licencias.some((f) => (f.id === 150 || f.id === 154 || f.id === 157) && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <div
                        className={'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'}
                        onScroll={this.handleScroll}
                    >
                        <Menu />
                    </div>
                    <Hidden xsDown>
                        <PanelInfo id={'manage_aux_message'} />
                    </Hidden>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        info: state.info,
    };
}

export default connect(
    mapStateToProps,
    null,
)(withRouter(Index));



// WEBPACK FOOTER //
// ./src/components/complex/reports/Index.js